import React from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import SubmenuUser from '../submenu/SubmenuUser'
import UserInfoOptions from './options/UserInfoOptions'
import UserInfoProfile from './UserInfoProfile'

const UserInfo = () => {
  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuUser />
		</MyBlock>
        <MyBlockHeader
            header={'Інформація про обліковий запис'}
            // isBack={true}
            options={
                <UserInfoOptions />
            }
        />
        {/* <MyBlock>
            <BoxOneOptions 
                boxId={boxId}
            />
        </MyBlock> */}
		<MyBlock>
            <UserInfoProfile />
		</MyBlock>
    </LayoutMain>
  )
}

export default UserInfo